<div (click)="item.isBlacklisted === false ? play_pause.play() : false" *ngIf="media"
  [ngStyle]="item.isBlacklisted === true ? {'opacity': '0.5'} : {}"
  [ngClass]="{current: isCurrent, playing: isPlaying, waitlist: item.isWaitlist}" class="smart-track-{{ mode }}">
  <div class="action__play-pause">
    <mwo-play-btn-playlist #play_pause [media]="media"></mwo-play-btn-playlist>
  </div>

  <div class="cover" *ngIf="mode === 'history'">
    <img cover class="cover-playlist" [src]="getImage(media)" (error)="img.src='assets/icons/default_icon.webp'"
      loading="lazy" />
  </div>

  <p class="titleAndArtist">
    <span class="title">{{ media.title }}<span *ngIf="isNew" class="label-new">New</span></span>
    <span class="artist">{{ media.artist?.name || media.artistName || media.artist }} <span *ngIf="mode === 'history'"
        class="event-name">
        - {{item.event?.name ? item.event?.name : item.tempo?.name }}</span>
    </span>
    <span *ngIf="mode === 'history'" class="played-date-mobile" style="font-size: 12px;">
      {{item.event?.name ? item.event?.name : item.tempo?.name }}</span>
    <span *ngIf="mode === 'history'" class="played-date-mobile">{{ item.playedDate[2] }}/{{item.playedDate[1] }}/
      {{item.playedDate[0]}}&nbsp;{{ item.playedDate[3].toString().padStart(2, '0') }}:{{ item.playedDate[4].toString().padStart(2, '0') }} </span>
  </p>

  <p *ngIf="mode !== 'blacklist' && mode !== 'history'" class="duration">{{ media.duration | duration:'mm:ss' }}
  <p *ngIf="mode === 'history'" class="duration">{{ item.playedDate[2] }}/{{ item.playedDate[1] }}/
  {{item.playedDate[0]}} &nbsp;{{ item.playedDate[3].toString().padStart(2, '0')  }}:{{ item.playedDate[4].toString().padStart(2, '0')  }} </p>

  <div class="container-action">

    <button (click)="unblacklist($event)" mat-raised-button *ngIf="item.blacklistDate && mode === 'blacklist'">
      {{('blacklist.restore' |
      translate)}}</button>

    <mwo-button [svgIcon]="'mwo-like'" *ngIf="mode === 'history' && !(isInWishlist$ | async)" [payload]="media"
      [active]="(isInWishlist$ | async)" (onClick)="like($event)"></mwo-button>
    <mwo-button [svgIcon]="'mwo-like'" *ngIf="mode === 'history' && (isInWishlist$ | async)" [payload]="media"
      [disabled]="(isInWishlist$ | async)" [active]="(isInWishlist$ | async)" (onClick)="unlike($event)"></mwo-button>

    <mwo-button [svgIcon]="'mwo-dislike'" *ngIf="mode === 'history' && (isInBlacklist$ | async)" [payload]="media"
      [disable]="!(isInBlacklist$ | async)" [active]="true" (onClick)="unBlacklist(event$)"></mwo-button>
    <mwo-button [svgIcon]="'mwo-dislike'" *ngIf="mode === 'history' && !(isInBlacklist$ | async)" [payload]="media"
      [disable]="(isInBlacklist$ | async)" [active]="false" (onClick)="blacklist($event)"></mwo-button>

  </div>

  <!-- <button matRipple class="blacklist-restore-track-button" *ngIf="item.blacklistDate && mode === 'blacklist'"
    (click)="unblacklist($event)">{{('blacklist.restore' | translate)}}</button>
  <button matRipple class="blacklist-restore-track-button-mobile" *ngIf="item.blacklistDate && mode === 'blacklist'"
    (click)="unblacklist($event)">{{('blacklist.restoreShort' | translate)}}</button> -->
</div>
